import Swiper from 'swiper';

export default function initializeCarousels() {
  // default carousels
  $('.swiper-container--default').each(function(index, element) {
    var $this = $(this);

    var initialSlideIndex = $this.find('[data-initial-slide]').index();
    initialSlideIndex = (initialSlideIndex !== -1) ? initialSlideIndex : 0;
    var effect = $this.data('effect') || 'slide';
    
    new Swiper($this, {
      effect: effect,
      fadeEffect: {
        crossFade: true
      },
      noSwiping: true,
      allowTouchMove: false,
      autoplay: {
        delay: 14000,
      },
      loop: true,
      initialSlide: initialSlideIndex,
      spaceBetween: 0,
      speed: 600,
      slidesPerView: 1,
      grabCursor: false,
      autoHeight: false,
      pagination: {
        el: $this.find('.swiper-pagination'),
        clickable: true,
        renderBullet: function(index, className) {
          var label = $(this.slides[index + 1]).data('bullet-label');
          var labelClass = $(this.slides[index + 1]).data('bullet-class');
          if (label === undefined) {
            return '<span class="' + className + '"></span>';

          } else {
            return '<span class="' + className + '"><span class="swiper-pagination__tab-label ' + labelClass + '">' + label + '</span></span>';
          }
        }
      },
      navigation: {
        nextEl: $this.find('.swiper-button-next')[0],
        prevEl: $this.find('.swiper-button-prev')[0]
      },

      // Fix pagination bullet inconsistent result
      // https://github.com/nolimits4web/swiper/issues/2428
      touchEventsTarget: 'wrapper'
    });
  });

  // carousel for partial panels
  $('.swiper-container--partial').each(function(index, element){
    var $this = $(this);

    var initialSlideIndex = $this.find('[data-initial-slide]').index();
    initialSlideIndex = (initialSlideIndex !== -1) ? initialSlideIndex : 0;

    var spaceBetween = $this.attr("data-space-between");
    if (typeof spaceBetween !== typeof undefined && spaceBetween !== false) {
      spaceBetween = parseInt(spaceBetween);
    } else {
      spaceBetween = 0;
    }
    
    new Swiper($this, {
      initialSlide: initialSlideIndex,
      grabCursor: true,
      autoHeight: false,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: spaceBetween,

      pagination: {
        el: $this.find('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: $this.find('.swiper-button-next')[0],
        prevEl: $this.find('.swiper-button-prev')[0]
      },

      // Fix pagination bullet inconsistent result
      // https://github.com/nolimits4web/swiper/issues/2428
      touchEventsTarget: 'wrapper'
    });
  });
}
